import { render, staticRenderFns } from "./resolve-duplicate-link.vue?vue&type=template&id=f6fccb34"
import script from "./resolve-duplicate-link.vue?vue&type=script&lang=js"
export * from "./resolve-duplicate-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports